import { render, staticRenderFns } from "./InquiryNavi.vue?vue&type=template&id=dffdd104&scoped=true&"
import script from "./InquiryNavi.vue?vue&type=script&lang=js&"
export * from "./InquiryNavi.vue?vue&type=script&lang=js&"
import style0 from "./InquiryNavi.vue?vue&type=style&index=0&id=dffdd104&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dffdd104",
  null
  
)

export default component.exports